class Controller {
  constructor(Events) {
    "ngInject";

    this.addItemEvent = Events.getAddEvent("captainAppVersions");
    this.paginateEvent = Events.getPaginateEvent("captainAppVersions");
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/captainAppVersions/captainAppVersions.controller.js